import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=21c4e553&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"
import style0 from "./loading.vue?vue&type=style&index=0&id=21c4e553&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c4e553",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21c4e553')) {
      api.createRecord('21c4e553', component.options)
    } else {
      api.reload('21c4e553', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=21c4e553&scoped=true", function () {
      api.rerender('21c4e553', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/src/components/loading.vue"
export default component.exports